import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "login-dialog w-full"
};
const _hoisted_2 = {
  key: 0,
  class: "login-box"
};
const _hoisted_3 = {
  class: "block"
};
const _hoisted_4 = {
  class: "block"
};
const _hoisted_5 = {
  class: "w-full"
};
const _hoisted_6 = {
  class: "text flex justify-center items-center pt-3 text-sm"
};
const _hoisted_7 = {
  key: 0
};
const _hoisted_8 = {
  class: "c-login flex justify-center"
};
const _hoisted_9 = {
  class: "p-2 w-full"
};
const _hoisted_10 = {
  key: 1,
  class: "register-box w-full"
};
const _hoisted_11 = {
  class: "block"
};
const _hoisted_12 = {
  class: "block"
};
const _hoisted_13 = {
  class: "block"
};
const _hoisted_14 = {
  class: "block"
};
const _hoisted_15 = {
  class: "block"
};
const _hoisted_16 = {
  class: "block"
};
const _hoisted_17 = {
  class: "block"
};
const _hoisted_18 = {
  class: "block"
};
const _hoisted_19 = {
  class: "w-full"
};
const _hoisted_20 = {
  class: "text text-sm flex justify-center items-center w-full pt-3"
};
const _hoisted_21 = {
  key: 1,
  class: "tip-result"
};
const _hoisted_22 = {
  class: "wechat-card"
};
import { onMounted, ref, watch } from "vue";
import { httpGet, httpPost } from "@/utils/http";
import { ElMessage } from "element-plus";
import { setUserToken } from "@/store/session";
import { validateEmail, validateMobile } from "@/utils/validate";
import { Checked, Close, Iphone, Lock, Message } from "@element-plus/icons-vue";
import SendMsg from "@/components/SendMsg.vue";
import { arrayContains } from "@/utils/libs";
import { getSystemInfo } from "@/store/cache";
import Captcha from "@/components/Captcha.vue";
import ResetPass from "@/components/ResetPass.vue";
import { setRoute } from "@/store/system";
import { useRouter } from "vue-router";
import { useSharedStore } from "@/store/sharedata";

// eslint-disable-next-line no-undef

export default {
  __name: 'LoginDialog',
  props: {
    show: Boolean
  },
  emits: ["hide", "success"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const showDialog = ref(false);
    watch(() => props.show, newValue => {
      showDialog.value = newValue;
    });
    const login = ref(true);
    const data = ref({
      username: process.env.VUE_APP_USER,
      password: process.env.VUE_APP_PASS,
      mobile: "",
      email: "",
      repass: "",
      code: "",
      invite_code: ""
    });
    const enableMobile = ref(false);
    const enableEmail = ref(false);
    const enableUser = ref(false);
    const enableRegister = ref(true);
    const wechatLoginURL = ref("");
    const activeName = ref("");
    const wxImg = ref("/images/wx.png");
    const captchaRef = ref(null);
    // eslint-disable-next-line no-undef
    const emits = __emit;
    const action = ref("login");
    const enableVerify = ref(false);
    const showResetPass = ref(false);
    const router = useRouter();
    const store = useSharedStore();
    onMounted(() => {
      const returnURL = `${location.protocol}//${location.host}/login/callback?action=login`;
      httpGet("/user/clogin?return_url=" + returnURL).then(res => {
        wechatLoginURL.value = res.data.url;
      }).catch(e => {
        console.log(e.message);
      });
      getSystemInfo().then(res => {
        if (res.data) {
          const registerWays = res.data["register_ways"];
          if (arrayContains(registerWays, "username")) {
            enableUser.value = true;
            activeName.value = "username";
          }
          if (arrayContains(registerWays, "email")) {
            enableEmail.value = true;
            activeName.value = "email";
          }
          if (arrayContains(registerWays, "mobile")) {
            enableMobile.value = true;
            activeName.value = "mobile";
          }
          // 是否启用注册
          enableRegister.value = res.data["enabled_register"];
          // 使用后台上传的客服微信二维码
          if (res.data["wechat_card_url"] !== "") {
            wxImg.value = res.data["wechat_card_url"];
          }
          enableVerify.value = res.data["enabled_verify"];
        }
      }).catch(e => {
        ElMessage.error("获取系统配置失败：" + e.message);
      });
    });
    const submit = verifyData => {
      if (action.value === "login") {
        doLogin(verifyData);
      } else if (action.value === "register") {
        doRegister(verifyData);
      }
    };

    // 登录操作
    const submitLogin = () => {
      if (!data.value.username) {
        return ElMessage.error("请输入用户名");
      }
      if (!data.value.password) {
        return ElMessage.error("请输入密码");
      }
      if (enableVerify.value) {
        captchaRef.value.loadCaptcha();
        action.value = "login";
      } else {
        doLogin({});
      }
    };
    const doLogin = verifyData => {
      data.value.key = verifyData.key;
      data.value.dots = verifyData.dots;
      data.value.x = verifyData.x;
      httpPost("/user/login", data.value).then(res => {
        setUserToken(res.data.token);
        store.setIsLogin(true);
        ElMessage.success("登录成功！");
        emits("hide");
        emits("success");
      }).catch(e => {
        ElMessage.error("登录失败，" + e.message);
      });
    };

    // 注册操作
    const submitRegister = () => {
      if (activeName.value === "username" && data.value.username === "") {
        return ElMessage.error("请输入用户名");
      }
      if (activeName.value === "mobile" && !validateMobile(data.value.mobile)) {
        return ElMessage.error("请输入合法的手机号");
      }
      if (activeName.value === "email" && !validateEmail(data.value.email)) {
        return ElMessage.error("请输入合法的邮箱地址");
      }
      if (data.value.password.length < 8) {
        return ElMessage.error("密码的长度为8-16个字符");
      }
      if (data.value.repass !== data.value.password) {
        return ElMessage.error("两次输入密码不一致");
      }
      if ((activeName.value === "mobile" || activeName.value === "email") && data.value.code === "") {
        return ElMessage.error("请输入验证码");
      }
      if (enableVerify.value && activeName.value === "username") {
        captchaRef.value.loadCaptcha();
        action.value = "register";
      } else {
        doRegister({});
      }
    };
    const doRegister = verifyData => {
      data.value.key = verifyData.key;
      data.value.dots = verifyData.dots;
      data.value.x = verifyData.x;
      data.value.reg_way = activeName.value;
      httpPost("/user/register", data.value).then(res => {
        setUserToken(res.data.token);
        ElMessage.success({
          message: "注册成功!",
          onClose: () => {
            emits("hide");
            emits("success");
          },
          duration: 1000
        });
      }).catch(e => {
        ElMessage.error("注册失败，" + e.message);
      });
    };
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_divider = _resolveComponent("el-divider");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_el_result = _resolveComponent("el-result");
      const _component_el_image = _resolveComponent("el-image");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [login.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_el_form, {
        model: data.value,
        class: "form"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_input, {
          placeholder: "账号",
          size: "large",
          modelValue: data.value.username,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => data.value.username = $event),
          autocomplete: "off"
        }, {
          prefix: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_unref(Iphone))]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_input, {
          placeholder: "请输入密码(8-16位)",
          maxlength: "16",
          size: "large",
          modelValue: data.value.password,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => data.value.password = $event),
          "show-password": "",
          autocomplete: "off"
        }, {
          prefix: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_unref(Lock))]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])]), _createVNode(_component_el_row, {
          class: "btn-row",
          gutter: 20
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 24
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              class: "login-btn",
              type: "primary",
              size: "large",
              onClick: submitLogin
            }, {
              default: _withCtx(() => _cache[16] || (_cache[16] = [_createTextVNode("登 录")])),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_cache[19] || (_cache[19] = _createTextVNode(" 还没有账号？ ")), _createVNode(_component_el_button, {
          size: "small",
          onClick: _cache[2] || (_cache[2] = $event => login.value = false)
        }, {
          default: _withCtx(() => _cache[17] || (_cache[17] = [_createTextVNode("注册")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "info",
          class: "forget",
          size: "small",
          onClick: _cache[3] || (_cache[3] = $event => showResetPass.value = true)
        }, {
          default: _withCtx(() => _cache[18] || (_cache[18] = [_createTextVNode("忘记密码？")])),
          _: 1
        })]), wechatLoginURL.value !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_el_divider, null, {
          default: _withCtx(() => _cache[20] || (_cache[20] = [_createElementVNode("div", {
            class: "text-center"
          }, "其他登录方式", -1)])),
          _: 1
        }), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createVNode(_component_el_button, {
          type: "success",
          class: "w-full",
          size: "large",
          href: wechatLoginURL.value,
          onClick: _cache[4] || (_cache[4] = $event => _unref(setRoute)(_unref(router).currentRoute.value.path))
        }, {
          default: _withCtx(() => _cache[21] || (_cache[21] = [_createElementVNode("i", {
            class: "iconfont icon-wechat mr-2"
          }, null, -1), _createTextVNode(" 微信登录 ")])),
          _: 1
        }, 8, ["href"])])])])) : _createCommentVNode("", true)])]),
        _: 1
      }, 8, ["model"])])) : (_openBlock(), _createElementBlock("div", _hoisted_10, [enableRegister.value ? (_openBlock(), _createBlock(_component_el_form, {
        key: 0,
        model: data.value,
        class: "form"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tabs, {
          modelValue: activeName.value,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => activeName.value = $event),
          class: "demo-tabs"
        }, {
          default: _withCtx(() => [enableMobile.value ? (_openBlock(), _createBlock(_component_el_tab_pane, {
            key: 0,
            label: "手机注册",
            name: "mobile"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createVNode(_component_el_input, {
              placeholder: "手机号码",
              size: "large",
              modelValue: data.value.mobile,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => data.value.mobile = $event),
              maxlength: "11",
              autocomplete: "off"
            }, {
              prefix: _withCtx(() => [_createVNode(_component_el_icon, null, {
                default: _withCtx(() => [_createVNode(_unref(Iphone))]),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_el_row, {
              gutter: 10
            }, {
              default: _withCtx(() => [_createVNode(_component_el_col, {
                span: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  placeholder: "验证码",
                  size: "large",
                  maxlength: "30",
                  modelValue: data.value.code,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => data.value.code = $event),
                  autocomplete: "off"
                }, {
                  prefix: _withCtx(() => [_createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [_createVNode(_unref(Checked))]),
                    _: 1
                  })]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              }), _createVNode(_component_el_col, {
                span: 12
              }, {
                default: _withCtx(() => [_createVNode(SendMsg, {
                  size: "large",
                  receiver: data.value.mobile,
                  type: "mobile"
                }, null, 8, ["receiver"])]),
                _: 1
              })]),
              _: 1
            })])]),
            _: 1
          })) : _createCommentVNode("", true), enableEmail.value ? (_openBlock(), _createBlock(_component_el_tab_pane, {
            key: 1,
            label: "邮箱注册",
            name: "email"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_13, [_createVNode(_component_el_input, {
              placeholder: "邮箱地址",
              size: "large",
              modelValue: data.value.email,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => data.value.email = $event),
              autocomplete: "off"
            }, {
              prefix: _withCtx(() => [_createVNode(_component_el_icon, null, {
                default: _withCtx(() => [_createVNode(_unref(Message))]),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_14, [_createVNode(_component_el_row, {
              gutter: 10
            }, {
              default: _withCtx(() => [_createVNode(_component_el_col, {
                span: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  placeholder: "验证码",
                  size: "large",
                  maxlength: "30",
                  modelValue: data.value.code,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => data.value.code = $event),
                  autocomplete: "off"
                }, {
                  prefix: _withCtx(() => [_createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [_createVNode(_unref(Checked))]),
                    _: 1
                  })]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              }), _createVNode(_component_el_col, {
                span: 12
              }, {
                default: _withCtx(() => [_createVNode(SendMsg, {
                  size: "large",
                  receiver: data.value.email,
                  type: "email"
                }, null, 8, ["receiver"])]),
                _: 1
              })]),
              _: 1
            })])]),
            _: 1
          })) : _createCommentVNode("", true), enableUser.value ? (_openBlock(), _createBlock(_component_el_tab_pane, {
            key: 2,
            label: "用户名注册",
            name: "username"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_15, [_createVNode(_component_el_input, {
              placeholder: "用户名",
              size: "large",
              modelValue: data.value.username,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => data.value.username = $event),
              autocomplete: "off"
            }, {
              prefix: _withCtx(() => [_createVNode(_component_el_icon, null, {
                default: _withCtx(() => [_createVNode(_unref(Iphone))]),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"])])]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_16, [_createVNode(_component_el_input, {
          placeholder: "请输入密码(8-16位)",
          maxlength: "16",
          size: "large",
          modelValue: data.value.password,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => data.value.password = $event),
          "show-password": "",
          autocomplete: "off"
        }, {
          prefix: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_unref(Lock))]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_17, [_createVNode(_component_el_input, {
          placeholder: "重复密码(8-16位)",
          size: "large",
          maxlength: "16",
          modelValue: data.value.repass,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => data.value.repass = $event),
          "show-password": "",
          autocomplete: "off"
        }, {
          prefix: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_unref(Lock))]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_18, [_createVNode(_component_el_input, {
          placeholder: "邀请码(可选)",
          size: "large",
          modelValue: data.value.invite_code,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => data.value.invite_code = $event),
          autocomplete: "off"
        }, {
          prefix: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_unref(Message))]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_19, [_createVNode(_component_el_button, {
          class: "login-btn w-full",
          type: "primary",
          size: "large",
          onClick: submitRegister
        }, {
          default: _withCtx(() => _cache[22] || (_cache[22] = [_createTextVNode("注 册")])),
          _: 1
        })]), _createElementVNode("div", _hoisted_20, [_cache[24] || (_cache[24] = _createTextVNode(" 已有账号？ ")), _createVNode(_component_el_button, {
          size: "small",
          onClick: _cache[14] || (_cache[14] = $event => login.value = true)
        }, {
          default: _withCtx(() => _cache[23] || (_cache[23] = [_createTextVNode("登录")])),
          _: 1
        })])]),
        _: 1
      }, 8, ["model"])) : (_openBlock(), _createElementBlock("div", _hoisted_21, [_createVNode(_component_el_row, {
        gutter: 20
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createVNode(_component_el_result, {
            icon: "error",
            title: "注册功能已关闭"
          }, {
            "sub-title": _withCtx(() => _cache[25] || (_cache[25] = [_createElementVNode("p", null, "抱歉，系统已关闭注册功能，请联系管理员添加账号！", -1)])),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_22, [_createVNode(_component_el_image, {
            src: wxImg.value
          }, null, 8, ["src"])])]),
          _: 1
        })]),
        _: 1
      })]))])), enableVerify.value ? (_openBlock(), _createBlock(Captcha, {
        key: 2,
        onSuccess: submit,
        ref_key: "captchaRef",
        ref: captchaRef
      }, null, 512)) : _createCommentVNode("", true), _createVNode(ResetPass, {
        onHide: _cache[15] || (_cache[15] = $event => showResetPass.value = false),
        show: showResetPass.value
      }, null, 8, ["show"])]);
    };
  }
};